import React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>Background Information</h1>
        </div>
        <ol>
          <li>
            <a href="#section1">Overview</a>
          </li>
          <li>
            <a href="#section2">REST APIs</a>
          </li>
          <li>
            <a href="#section3">OAuth 2</a>
          </li>
          <li>
            <a href="#section4">Socket.IO</a>
          </li>
        </ol>
        <br />
        <div id="section1" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">1 Overview</h4>
          </div>
          <div className="panel-body">
            <p>
              The various programs and protocols used to interface with Avaya
              Spaces are widely used, and should be mostly familiar to
              developers with experience using other APIs. If they’re not
              familiar to you yet, that’s okay too- none of them are too
              difficult to understand. The links below will provide you with a
              working understand of these systems, and are intended to be used
              as a springboard for further research.
            </p>
          </div>
        </div>
        <div id="section2" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">2 REST APIs</h4>
          </div>
          <div className="panel-body">
            <p>
              Avaya Spaces offers a Representational State Transfer (REST) API
              for third-party interfaces. The concept of REST systems, the HTTP
              protocol, and basic internet architecture should be well
              understood.
            </p>
            <ul>
              <li>
                <a href="https://code.tutsplus.com/tutorials/http-the-protocol-every-web-developer-must-know-part-1--net-31177">
                  https://code.tutsplus.com/tutorials/http-the-protocol-every-web-developer-must-know
                </a>
                : basic HTTP requests and URLs
              </li>
              <li>
                <a href="http://rest.elkstein.org/">
                  http://rest.elkstein.org/
                </a>
                : A quick tutorial on how REST systems works
              </li>
              <li>
                <a href="https://en.wikipedia.org/wiki/Representational_state_transfer">
                  https://en.wikipedia.org/wiki/Representational_state_transfer
                </a>
                : A Wikipedia article on REST, for developers who want to go
                further in depth
              </li>
            </ul>
            <p>
              Additionally, we recommend Postman (
              <a href="https://www.getpostman.com/">
                https://www.getpostman.com/
              </a>
              ) for experimenting with HTTP requests and APIs.
            </p>
          </div>
        </div>
        <div id="section3" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">3 OAuth 2</h4>
          </div>
          <div className="panel-body">
            <p>
              Avaya Cloud Identity implements OAuth 2 as its protocol for authorization
              and authentication.
            </p>
            <ul>
              <li>
                <a href="https://www.digitalocean.com/community/tutorials/an-introduction-to-oauth-2">
                  https://www.digitalocean.com/community/tutorials/an-introduction-to-oauth-2
                </a>
                : A comprehensive guide to OAuth 2
              </li>
              <li>
                <a href="https://oauth.net/2/">https://oauth.net/2/</a>: An
                introductory site to OAuth 2
              </li>
              <li>
                <a href="https://tools.ietf.org/html/rfc6749">
                  https://tools.ietf.org/html/rfc6749
                </a>
                : The official OAuth 2 protocol specifications
              </li>
            </ul>
            <p>
              For more information on how Avaya Spaces uses OAuth 2, see the{" "}
              <Link to="/guides/authorizationoverview">
                Authorization Guide
              </Link>
              .
            </p>
          </div>
        </div>
        <div id="section4" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">4 Socket.IO</h4>
          </div>
          <div className="panel-body">
            <p>
              Avaya Spaces uses a websocket library called Socket.IO as it's
              real time communications protocol.
            </p>
            <ul>
              <li>
                <a href="https://en.wikipedia.org/wiki/Socket.IO">
                  https://en.wikipedia.org/wiki/Socket.IO
                </a>
                : the Wikipedia article for Socket.IO provides a brief but
                useful overview of the framework.
              </li>
              <li>
                <a href="https://socket.io/">https://socket.io/</a>: The
                official Socket.io website
              </li>
              <li>
                <a href="https://socket.io/get-started/chat/">
                  https://socket.io/get-started/chat/
                </a>
                : A basic Socket.IO tutorial taken straight from the Socket.IO
                website
              </li>
              <li>
                <a href="https://www.tutorialspoint.com/socket.io/index.htm">
                  https://www.tutorialspoint.com/socket.io/index.htm
                </a>
                : A lengthy, comprehensive tutorial
              </li>
            </ul>
            <p>
              For more information on how Socket.IO is used in Avaya Spaces, see
              the <Link to="/guides/socketio">Socket.IO Guide</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
